
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { VrstaDokumentaOtpremnica } from '@kodit/core/data-api';

@Component({
  selector: 'kodit-slanje-robe-page',
  templateUrl: './slanje-robe-page.component.html',
  styleUrls: ['./slanje-robe-page.component.scss']
})
export class SlanjeRobePageComponent implements OnInit, OnDestroy {

  private _subs = new Subscription();

  activeIndex: number = 0;
  allowedIndecies = [0, 1];
  protected readonly VrstaDokumentaOtpremnica = VrstaDokumentaOtpremnica;

  constructor(
    private route: ActivatedRoute,
    private _router: Router) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.activeTab) {
        const activeTabIdx = Number.parseInt(params.activeTab);
        if (!isNaN(activeTabIdx) && this.allowedIndecies.includes(0, 0)) {
          this.activeIndex = activeTabIdx;
          //this._tableService.setActiveTab = activeTabIdx;
        }
      }
    });

    // this._subs.add(
    //   this._tableService.getActiveTab.subscribe((tabIndex) => {
    //     this.activeIndex = tabIndex;
    //   })
    // );
  }

  handleIndexChange(tabIndex: number) {
    //this._tableService.setActiveTab = tabIndex;
  }

  ngOnDestroy(): void {
    //reset active tab if we leaving the page
    // if (
    //   this._router.routerState.snapshot.url.indexOf('pdv-evidencije') === -1
    // ) {
    //   this._tableService.resetActiveTab();
    // }
    this._subs.unsubscribe();
  }

}
